import gql from 'graphql-tag';

const GET_ACCOUNT = gql`
  query getAccount {
    account {
      email
    }
  }
`;

export default GET_ACCOUNT;
